import { Link, usePage } from '@inertiajs/react'
import { cn } from '@/shared/lib/utils'
import { t } from '@/shared/lib/i18n'
import { organizationPath, sitesPath, departmentsPath, unitsPath } from '@/shared/lib/routes'

const OrganizationTabs = () => {
  const { url } = usePage()

  const tabs = [
    { label: t('nav.organization'), href: organizationPath() },
    { label: t('nav.sites'), href: sitesPath() },
    { label: t('nav.departments'), href: departmentsPath() },
    { label: t('nav.units'), href: unitsPath() },
  ]

  const tabClass = (active: boolean) =>
    cn(
      'shrink-0 whitespace-nowrap border-b-2 px-4 py-2 text-sm font-medium transition-colors',
      active
        ? 'border-primary text-foreground'
        : 'border-transparent text-muted-foreground hover:text-foreground',
    )

  return (
    <div
      className="flex overflow-x-auto border-b mb-6"
      role="tablist"
      aria-label={t('nav.administration')}
    >
      {tabs.map(({ label, href }) => (
        <Link key={href} href={href} className={tabClass(url.startsWith(href))}>
          {label}
        </Link>
      ))}
    </div>
  )
}

export default OrganizationTabs
